import { render, staticRenderFns } from "./upload-imageTwoOne.vue?vue&type=template&id=33c5157a&scoped=true"
import script from "./upload-imageTwoOne.vue?vue&type=script&lang=ts"
export * from "./upload-imageTwoOne.vue?vue&type=script&lang=ts"
import style0 from "./upload-imageTwoOne.vue?vue&type=style&index=0&id=33c5157a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5157a",
  null
  
)

export default component.exports